import { useFormContext } from 'react-hook-form';
import type { JSX } from 'react';
import type { FieldHiddenSchema } from '~/shared/domain/models';

export type FieldHiddenProps = {
  data: FieldHiddenSchema;
};

type Component = (props: FieldHiddenProps) => JSX.Element;

export const FieldHidden: Component = ({ data }) => {
  const { register } = useFormContext();
  const { name } = data;

  return <input type="hidden" {...register(name)} />;
};
